import { idConfig } from '@glowforge/builder-components/lib/util/shared-configs';

export default {
  name: 'ReferralWidget',
  friendlyName: 'Referral Widget',
  image:
    'https://cdn.builder.io/api/v1/image/assets%2F69fac0673d2644f0a0a962e1cb3045ef'
    + '%2Fb08ad2d1eee44230b8f3675858105e12',
  description:
    'Shows a FriendBuy-style referral card with live login, share link, and referral stats.',
  noWrap: true,
  inputs: [
    idConfig,
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpg', 'jpeg', 'png', 'webp', 'svg'],
      defaultValue:
        '//images.ctfassets.net/ljtyf78xujn2/4U7Fe73owMa6yuKm0UyqmI/'
        + '92bbd608e37f0d55791c8acee3944628/Bailey_S.jpg',
    },
    {
      name: 'backgroundPosition',
      type: 'string',
      defaultValue: 'center right',
    },
    {
      name: 'panelBackgroundColor',
      type: 'color',
      defaultValue: 'rgba(10, 56, 61, 0.96)',
    },
    {
      name: 'accentColor',
      type: 'color',
      defaultValue: '#40c7e6',
    },
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Refer a Friend',
    },
    {
      name: 'headline',
      type: 'string',
      defaultValue: 'Get Up to $500!',
    },
    {
      name: 'description',
      type: 'longText',
      defaultValue:
        'Give your friends $500 off a Pro or Pro HD, $250 off a Plus or Plus HD, '
        + 'a $50 gift card with Glowforge Aura, or a $25 gift card with Glowforge '
        + 'Spark and earn equal Glowforge credit for yourself after their purchase.',
    },
    {
      name: 'loadingText',
      type: 'string',
      defaultValue: 'Loading your referral link...',
    },
    {
      name: 'loginMessage',
      type: 'longText',
      defaultValue: 'Log in to your account to get started',
    },
    {
      name: 'loginButtonText',
      type: 'string',
      defaultValue: 'Log in',
    },
    {
      name: 'shareLabel',
      type: 'string',
      defaultValue: 'Share your referral link anywhere:',
    },
    {
      name: 'copyButtonText',
      type: 'string',
      defaultValue: 'Copy',
    },
    {
      name: 'copiedButtonText',
      type: 'string',
      defaultValue: 'Copied',
    },
    {
      name: 'shareWithLabel',
      type: 'string',
      defaultValue: 'Or share with:',
    },
    {
      name: 'hideSocialShare',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'hideMetrics',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'socialShareText',
      type: 'string',
      defaultValue: 'Take a look at Glowforge with my referral link.',
    },
    {
      name: 'emailShareSubject',
      type: 'string',
      defaultValue: 'Check out Glowforge',
    },
    {
      name: 'termsText',
      type: 'string',
      defaultValue: 'Terms',
    },
    {
      name: 'termsUrl',
      type: 'url',
      defaultValue: 'https://glowforge.com/m/referral-terms',
    },
    {
      name: 'errorHeading',
      type: 'string',
      defaultValue: 'We could not load your referral link',
    },
    {
      name: 'errorDescription',
      type: 'longText',
      defaultValue: 'Refresh the page and try again.',
    },
    {
      name: 'previewState',
      type: 'string',
      enum: ['live', 'loading', 'logged-out', 'error', 'ready'],
      defaultValue: 'live',
      helperText:
        'Builder preview override. Live uses the real user + referral APIs.',
    },
  ],
};
